export default "__VITE_ASSET__DFCUBtwZ__"